<div
  class="auth-wrapper"
  [class]="asideData?.baseClass"
>
  <div class="auth-wrapper-container">
    <div class="auth-actions">
      <base-language-switch
        [color]="colors.white"
        class="auth-wrapper-language-switch ms-3"
      ></base-language-switch>
      <div class="d-flex justify-content-start justify-content-md-end flex-wrap gap-2">
        <ng-container *ngFor="let link of portalSettings.links.visibility.header; trackBy: trackByLink">
          <base-button
            *ngIf="link !== 'privacyPolicy' || !isRegisterPage"
            (btnClick)="goTo(portalSettings.links.urls[link])"
            [size]="buttonSize.sm"
            [label]="link"
            color="white"
          ></base-button>
        </ng-container>
      </div>
    </div>

    <div class="auth-form d-flex flex-column align-items-center justify-content-center">
      <div class="auth-intro text-center">
        <img
          class="img-fluid"
          [src]="logo"
          alt="Logo"
        />
        <h2 class="application-description m-0">
          {{ asideData?.description | baseIsEmpty | translate }}
        </h2>
      </div>
      <div class="d-flex justify-content-center align-items-center w-100 px-3">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
